import { Modal } from "@mantine/core";
const CustomModal = (props: any) => {
  const { children } = props;
  return <Modal {...props}>{children}</Modal>;
};

export default CustomModal;
